import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelCatInTheBoxEaster: FC<SvgIconProps> = ({ viewBox = '0 0 254 181', ...props }) => (
  <SvgIcon viewBox={viewBox} height="181" width="254" {...props}>
    <path
      opacity=".1"
      d="M37.6 106.967c0 .4-2.1.7-4.7.7s-4.7-.3-4.7-.7c0-.4 2.1-.7 4.7-.7 2.6.1 4.7.4 4.7.7ZM220.6 122.167c0 .4-2.5.8-5.5.8-3.1 0-5.5-.4-5.5-.8s2.5-.8 5.5-.8c3.1 0 5.5.4 5.5.8Z"
      fill="#000"
    />
    <mask
      id="mask0_1891_11612"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x="206"
      y="100"
      width="18"
      height="23"
    >
      <path
        d="M223 114.667c-.8 4.6-5.3 8.2-9.9 7.3-4.6-.8-7.5-5.8-6.7-10.3.8-4.6 4.9-12 10.5-11 5.3 1 6.9 9.4 6.1 14Z"
        fill="url(#paint0_linear_1891_11612)"
      />
    </mask>
    <g mask="url(#mask0_1891_11612)">
      <path
        d="M223 114.667c-.8 4.6-5.3 8.2-9.9 7.3-4.6-.8-7.5-5.8-6.7-10.3.8-4.6 4.9-12 10.5-11 5.3 1 6.9 9.4 6.1 14Z"
        fill="url(#paint1_linear_1891_11612)"
      />
      <path
        d="M223.522 106.195a2.6 2.6 0 1 0-4.771-2.069 2.6 2.6 0 0 0 4.771 2.069ZM210.7 107.567a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM207.6 119.467a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM213.5 115.067a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM222.2 117.467a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM216.7 124.467a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2Z"
        fill="#EF707C"
      />
      <g opacity=".3">
        <path
          opacity=".3"
          d="M222.2 106.067c.2 1.7.1 3.4-.1 4.7-.9 4.9-5.7 8.8-10.6 7.9-1.9-.3-3.5-1.3-4.7-2.7.9 3 3.3 5.5 6.4 6.1 4.6.8 9-2.8 9.9-7.3.3-2.5.1-5.9-.9-8.7Z"
          fill="url(#paint2_linear_1891_11612)"
        />
      </g>
    </g>
    <path
      opacity=".5"
      d="m112.5 160.667 39.3-7.6-.8-3.8.6-4.2-74.2-36.8-50.5 9.9 85.6 42.5Z"
      fill="url(#paint3_linear_1891_11612)"
    />
    <path d="m110.4 143.267 23.1-4.4-46.5-23.2-22.9 4.4 46.3 23.2Z" fill="#996A0D" />
    <path d="m133.5 65.467 81.6-14.5-46.5-23.1-81.6 14.7 46.5 22.9Z" fill="#FDDE84" />
    <path d="m133.5 65.467 18.7-10.9-46.2-23.2-19 11.2 46.5 22.9Z" fill="#996A0D" />
    <path d="M133.5 65.467v73.4l-46.5-23.2v-73.1l46.5 22.9Z" fill="#634509" />
    <path d="M65.4 38.967v72.3l21.7 4.4v-73.1l-21.7-3.6Z" fill="#C39000" />
    <path opacity=".5" d="m106.2 144.267 27.3-5.5v-32.8l-73.8 15.1 46.5 23.2Z" fill="url(#paint4_linear_1891_11612)" />
    <path opacity=".1" d="M125.7 113.567c0 .5-2.7.9-6 .9s-6-.4-6-.9 2.7-.9 6-.9 6 .4 6 .9Z" fill="#000" />
    <mask
      id="mask1_1891_11612"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x="110"
      y="89"
      width="19"
      height="25"
    >
      <path
        d="M128.8 103.767c0 5.1-4.1 9.8-9.2 9.8s-9.2-4.7-9.2-9.8c0-5.1 2.9-13.8 9.2-13.8 5.8-.1 9.2 8.7 9.2 13.8Z"
        fill="url(#paint5_linear_1891_11612)"
      />
    </mask>
    <g mask="url(#mask1_1891_11612)">
      <path
        d="M128.8 103.767c0 5.1-4.1 9.8-9.2 9.8s-9.2-4.7-9.2-9.8c0-5.1 2.9-13.8 9.2-13.8 5.8-.1 9.2 8.7 9.2 13.8Z"
        fill="url(#paint6_linear_1891_11612)"
      />
      <path
        d="M119.7 102.667c-5.7 0-10.1-1.4-10.3-1.5l1.1-3.2s4.1 1.3 9.3 1.3c5.7 0 10.6-1.3 10.6-1.4l.9 3.2c-.3.1-5.4 1.6-11.6 1.6ZM119.7 95.267c-5.6 0-9.8-1.4-10-1.5l.5-1.4c.1 0 4.2 1.4 9.5 1.4 5.9 0 10.8-1.4 10.9-1.4l.4 1.5c-.2 0-5.2 1.4-11.3 1.4Zm-9.8-2.2.2-.7-.2.7Z"
        fill="#FFF7E4"
      />
      <path
        d="M119.7 93.767c-5.5 0-9.9-1.4-9.9-1.4l.2-.6s4.3 1.4 9.7 1.4c5.9 0 10.9-1.4 11-1.4l.2.6c-.1 0-5.2 1.4-11.2 1.4Z"
        fill="#FFC665"
      />
      <path
        d="M119.5 108.667c-5.8 0-10.3-1.5-10.5-1.5l1.3-4-.7 2 .7-2s4 1.3 9.1 1.3c5.7 0 10.5-1.3 10.5-1.3l1.1 4c-.1 0-5.2 1.5-11.5 1.5Z"
        fill="#DC5B29"
      />
      <path
        d="M119.4 115.567c-.1 0-.1 0 0 0-5.7 0-10.1-1.4-10.3-1.5l1.1-3.2s4.1 1.3 9.3 1.3c5.7 0 10.6-1.3 10.6-1.4l.9 3.2c-.3.2-5.5 1.6-11.6 1.6ZM119.7 99.467c-5.6 0-9.8-1.4-10-1.4l.4-1.1s4.2 1.4 9.6 1.4c5.9 0 10.9-1.4 10.9-1.4l.3 1.1c-.2 0-5.2 1.4-11.2 1.4ZM119.6 109.567c-5.6 0-9.8-1.4-10-1.4l.4-1.1s4.2 1.4 9.6 1.4c5.9 0 10.9-1.4 10.9-1.4l.3 1.1c-.2 0-5.2 1.4-11.2 1.4Z"
        fill="#FFC665"
      />
      <path
        d="M120.3 100.967c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6c.3.1.6.3.6.6ZM122.7 100.967c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6ZM125.1 100.767c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.2.6.6ZM126.6 101.067a.6.6 0 1 0-.001-1.201.6.6 0 0 0 .001 1.201ZM114.8 101.267a.6.6 0 1 0-.001-1.201.6.6 0 0 0 .001 1.201ZM113 100.267c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6c.4 0 .6.3.6.6ZM117.8 100.967c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6Z"
        fill="#FFA752"
      />
      <path
        d="M120.2 106.467c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6ZM122.7 106.367c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6ZM125 106.167c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6c.4 0 .6.3.6.6ZM127.1 105.867c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6ZM115.4 106.067c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6ZM112.4 106.267a.6.6 0 1 0-.001-1.201.6.6 0 0 0 .001 1.201ZM117.8 106.367c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6Z"
        fill="#FFF7E4"
      />
      <g opacity=".29">
        <path
          opacity=".29"
          d="M126.2 94.567c.5 1.8.8 3.6.8 5.1 0 5.4-4.4 10.5-9.9 10.5-2.1 0-4-.7-5.6-2 1.6 3 4.6 5.3 8.1 5.3 5.1 0 9.2-4.7 9.2-9.8 0-2.6-.9-6.2-2.6-9.1Z"
          fill="url(#paint7_linear_1891_11612)"
        />
      </g>
    </g>
    <path
      d="M81.8 62.067c-2-.6-5.2-2.3-9-1.1l8 17s1.2.4 2.7.7c11.5 3.3 21.9 1.1 21.9 1.1l-.2-6.5s-16.1-9-23.4-11.2Z"
      fill="url(#paint8_linear_1891_11612)"
    />
    <path
      d="M105.5 75.167c-.7-.1-17.2-5.4-25.4-7.3-1.5-.3-3.3-.7-5.3-.9l1.4 5.5c13.7 5.6 29.9 5.9 29.9 5.9.7 0-.3-3.2-.6-3.2Z"
      fill="url(#paint9_radial_1891_11612)"
    />
    <path
      d="M82.9 90.367c-3.2-.2-7.8-5.6-10.1-12 0 0-4.8-14.6-.1-17.4.1 0 24.2 30.5 10.2 29.4Z"
      fill="url(#paint10_linear_1891_11612)"
    />
    <path
      d="M112.7 69.267s-26.7-41.3-21.8-47.3c4.9-6 16.2-1 29.6 43.6l-7.8 3.7Z"
      fill="url(#paint11_radial_1891_11612)"
    />
    <path
      d="M100.9 32.067c-6.4-10.6-6-4.2-3.3 3.2 1.4 3.7 14.6 31 14.9 31.5.8 1.4 6 4.5 5-.1-1.5-7.7-15.9-33.5-16.6-34.6Z"
      fill="url(#paint12_radial_1891_11612)"
    />
    <path
      d="M165.1 92.967c-7.4-3.2-15.2-5.6-19.2-7.5-4-1.8-21.8 17.6-18.5 20.5 2.1 4.9 4.3 9.2 6.5 13l35.5-8.7-4.3-17.3Z"
      fill="url(#paint13_radial_1891_11612)"
    />
    <path
      d="M167.6 102.867c-3.8-2.2-8.6-3.1-12.7-3.9 0 0-9-1.7-11.9 1.7-3 3.5 0 12.2 0 12.3.3 1.1.7 2.3 1.1 3.5l25.4-6.2-1.9-7.4Z"
      fill="url(#paint14_radial_1891_11612)"
    />
    <path
      d="M147 115.767c-1.6-1-3.3-2-5.2-2.7.2-.1-6.6 5.3-6.5 5.3l.2.2 11.5-2.8Z"
      fill="url(#paint15_radial_1891_11612)"
    />
    <path
      d="M161.3 112.067c0 .1.1.1 0 0l5.5-1.2c0-.3-.1-.6-.1-1-1.5-7.8-1.3-12.7-8-19.1-.1-.1-4.8 7.2-4.7 7 2 4.3 5.5 7.2 6.3 10 .2.8-.6 2.6 1 4.3Z"
      fill="url(#paint16_radial_1891_11612)"
    />
    <path
      d="M145 76.067c-4.4-3.2-14.6-10.8-21.6-12.2-6.5-1.4-10.2 1.1-14.5 3.6-.6.4-1.3-.1-1.7-.9.2.7-.1 1.8-.2 2.3-1-.4-2-.8-3-1.4 1.7 1.5 2.5 2.3 2.1 3.1-2.1 3.3-3.6 6.9-2.8 10.9 1.4 7.2 7.3 19.3 14.2 25.4 7 6.2 15.1 4.4 24.3-5.6 9-10.1 8.6-21.3 3.2-25.2Z"
      fill="url(#paint17_radial_1891_11612)"
    />
    <path
      d="M132 79.867c.5.5.5 1.4-.1 1.9-.5.5-1.4.5-1.9-.1-.5-.5-.9-1.8-.3-2.3.5-.5 1.8-.1 2.3.5Z"
      fill="url(#paint18_radial_1891_11612)"
    />
    <path
      d="M123.2 89.367c.5.5.5 1.4-.1 1.9-.5.5-1.4.5-1.9-.1-.5-.5-.9-1.8-.3-2.3.5-.5 1.8-.1 2.3.5Z"
      fill="url(#paint19_radial_1891_11612)"
    />
    <path
      d="M125.6 96.767c-2.1-1.9-1.6-7.1 1.5-10.5 3.1-3.4 8.5-4.5 10.6-2.6 2.1 1.9.1 6-3 9.4-3.2 3.5-7.1 5.6-9.1 3.7Z"
      fill="#EFEEF3"
    />
    <path
      d="M131.4 95.967s.5-1 .8-2c.4-1.1.7-2.4.7-2.4s3.6-1.6 4-1.8c.7-.3.9 3.1-.9 4.9-1.6 1.5-3.8 1-4.6 1.3Z"
      fill="url(#paint20_radial_1891_11612)"
    />
    <path
      opacity=".2"
      d="M135.3 85.067c-2-1.8-2.1-5 0-7.2 2.4-2.7 5.6-1.7 6.7-.6 2.6 2.4 1.9 5.3.2 7.2-1.8 1.9-4.6 2.8-6.9.6Z"
      fill="url(#paint21_radial_1891_11612)"
    />
    <path
      opacity=".2"
      d="M119.4 102.467c-2-1.8-2.1-5 0-7.2 2.4-2.7 5.6-1.7 6.7-.6 2.6 2.4 1.9 5.3.2 7.2-1.8 1.8-4.6 2.7-6.9.6Z"
      fill="url(#paint22_radial_1891_11612)"
    />
    <path d="M132.9 91.667c.6.5 3 2.7 3 2.7l-1.2 1.3-2.2-1.6s.3-2.6.4-2.4Z" fill="url(#paint23_radial_1891_11612)" />
    <path d="M133 91.567c.6.5 3 2.7 3 2.7l1.2-1.3-1.8-2c-.1 0-2.6.6-2.4.6Z" fill="url(#paint24_radial_1891_11612)" />
    <path
      d="M137.8 84.567c1.6 3.8-1.8 6.1-5.2 6.6-.2 0-.2.1-.2.3.5 2.6-1.9 6.2-4.7 5.6-.3-.1-.4.4-.1.4 1.7.3 3-.6 4-1.8.5-.7.9-1.4 1.1-2.2.2-.6-.1-1.9.5-2 3.6-.6 6.7-3.3 5.1-7.1-.1-.2-.6-.1-.5.2Z"
      fill="url(#paint25_radial_1891_11612)"
    />
    <path
      d="M132.2 91.467c-1.1.9-3.9 1.2-5.1 0-1.3-1.2.4-3.3 1.3-4.3 1.3-1.5 2.3-1.5 3.2-1.5 2.1.2 2.5 4.2.6 5.8Z"
      fill="url(#paint26_radial_1891_11612)"
    />
    <path
      d="M99.5 78.267c-.8-.4-3.6-2.3-1.3-3.8 2-1.3 3 1.4 3.1 1.6.1.2.1-2.7 1.9-2.5 3 .3.7 3.5.5 3.8-.1.2 3-2.3 3.8.6.6 2.2-2 2.6-3.5 2.4 0 0 3.1 2.6 1 3.9-2.9 1.9-3.5-1.1-3.7-2.3 0 0-.6 3.8-3.1 2.1-1-.7-.3-2.1 1-3.2 0 0-3.3 1.6-3.3-1.4.2-2.2 3.6-1.2 3.6-1.2Z"
      fill="url(#paint27_radial_1891_11612)"
    />
    <path
      d="M101.2 79.967c-.4-.4-.4-1 0-1.5.4-.4 1.1-.5 1.5-.1.4.4.4 1 0 1.5-.5.4-1.1.4-1.5.1Z"
      fill="url(#paint28_radial_1891_11612)"
    />
    <path d="M133.5 65.467v73.4l81.6-14.7v-73.2l-81.6 14.5Z" fill="#FCCE09" />
    <path
      opacity=".1"
      d="M166.9 141.567c0 .7-3.9 1.2-8.7 1.2-4.8 0-8.7-.6-8.7-1.2 0-.7 3.9-1.2 8.7-1.2 4.8 0 8.7.5 8.7 1.2Z"
      fill="#000"
    />
    <mask
      id="mask2_1891_11612"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x="144"
      y="107"
      width="28"
      height="35"
    >
      <path
        d="M171.3 127.467c0 7.3-5.9 14.1-13.2 14.1-7.3 0-13.2-6.8-13.2-14.1s4.2-19.9 13.2-19.9c8.3 0 13.2 12.6 13.2 19.9Z"
        fill="url(#paint29_linear_1891_11612)"
      />
    </mask>
    <g mask="url(#mask2_1891_11612)">
      <path
        d="M171.3 127.467c0 7.3-5.9 14.1-13.2 14.1-7.3 0-13.2-6.8-13.2-14.1s4.2-19.9 13.2-19.9c8.3 0 13.2 12.6 13.2 19.9Z"
        fill="url(#paint30_linear_1891_11612)"
      />
      <path
        d="M158.2 125.767c-8.3 0-14.6-2.1-14.9-2.2l1.5-4.6c.1 0 5.9 1.9 13.3 1.9 8.3 0 15.2-1.9 15.3-2l1.3 4.6c-.2.3-7.6 2.3-16.5 2.3ZM158.2 115.167c-8.1 0-14.2-2-14.4-2.1l.7-2.1c.1 0 6.1 2 13.7 2 8.4 0 15.6-2 15.6-2l.6 2.1c-.3.1-7.4 2.1-16.2 2.1Zm-14.1-3.1.3-1-.3 1Z"
        fill="#FFF7E4"
      />
      <path
        d="M158.2 113.167c-8 0-14.2-2-14.2-2.1l.3-.9c.1 0 6.1 2 13.9 2 8.5 0 15.7-2 15.8-2l.3.9c-.1 0-7.4 2.1-16.1 2.1Z"
        fill="#FFC665"
      />
      <path
        d="M157.9 134.467c-8.4 0-14.8-2.1-15-2.2l1.9-5.7-1 2.9 1-2.9c.1 0 5.8 1.9 13.1 1.9 8.1 0 15-1.9 15.1-1.9l1.6 5.8c-.2 0-7.7 2.1-16.7 2.1Z"
        fill="#DC5B29"
      />
      <path
        d="M157.7 144.467c-8.3 0-14.6-2.1-14.9-2.2l1.5-4.6c.1 0 5.9 1.9 13.3 1.9 8.3 0 15.2-1.9 15.3-2l1.3 4.6c-.2.2-7.6 2.3-16.5 2.3ZM158.2 121.167c-8 0-14.1-2-14.4-2.1l.5-1.6c.1 0 6.1 2 13.8 2 8.5 0 15.6-2 15.7-2l.5 1.6c-.3.2-7.4 2.1-16.1 2.1ZM158 135.767c-8 0-14.1-2-14.4-2.1l.5-1.6c.1 0 6.1 2 13.8 2 8.5 0 15.6-2 15.7-2l.5 1.6c-.2.1-7.4 2.1-16.1 2.1Z"
        fill="#FFC665"
      />
      <path
        d="M159 123.467c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.5.9.9ZM162.6 123.467c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9ZM165.9 123.067c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9c.6.1.9.4.9.9ZM168.1 123.567a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM151.2 123.867a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM148.6 122.467c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9ZM155.5 123.467c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9Z"
        fill="#FFA752"
      />
      <path
        d="M159 131.367c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9ZM162.5 131.267c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9ZM165.9 130.867c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9c.5.1.9.5.9.9ZM168.9 130.567c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9ZM152 130.867c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9ZM147.7 131.167a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM155.4 131.267c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9c.6 0 .9.4.9.9Z"
        fill="#FFF7E4"
      />
      <g opacity=".29">
        <path
          opacity=".29"
          d="M167.6 114.267c.8 2.6 1.2 5.2 1.2 7.4 0 7.8-6.3 15.2-14.2 15.2-3 0-5.7-1.1-8-2.8 2.2 4.4 6.6 7.6 11.6 7.6 7.3 0 13.2-6.8 13.2-14.1-.1-3.9-1.4-9.1-3.8-13.3Z"
          fill="url(#paint31_linear_1891_11612)"
        />
      </g>
    </g>
    <path d="M133.5 65.467v73.4l18.5 14.9v-74.2l-18.5-14.1Z" fill="#FDDE84" />
    <path
      opacity=".1"
      d="M187.7 145.467c0 .7-3.9 1.2-8.7 1.2-4.8 0-8.7-.6-8.7-1.2 0-.7 3.9-1.2 8.7-1.2 4.8-.1 8.7.5 8.7 1.2Z"
      fill="#000"
    />
    <mask
      id="mask3_1891_11612"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x="164"
      y="115"
      width="27"
      height="31"
    >
      <path
        d="M189.2 127.167c3.1 6 1.1 14.1-4.9 17.1-6 3.1-13.7 0-16.8-6-3.1-6-5-18.1 2.4-21.9 6.9-3.5 16.3 4.8 19.3 10.8Z"
        fill="url(#paint32_linear_1891_11612)"
      />
    </mask>
    <g mask="url(#mask3_1891_11612)">
      <path
        d="M189.2 127.167c3.1 6 1.1 14.1-4.9 17.1-6 3.1-13.7 0-16.8-6-3.1-6-5-18.1 2.4-21.9 6.9-3.5 16.3 4.8 19.3 10.8Z"
        fill="url(#paint33_linear_1891_11612)"
      />
      <path
        d="M171.7 121.267c-4.4 2.2-8.2 2.9-8.4 2.9l-.3-2 .2 1-.2-1s3.7-.6 7.8-2.7c4.5-2.3 7.7-5.3 7.7-5.3l1.4 1.5c-.1.1-3.5 3.2-8.2 5.6ZM175.9 129.667c-6.6 3.4-12.5 4.3-12.7 4.4l-.3-2c.1 0 5.8-.9 12.1-4.2 6.9-3.5 11.9-8.2 12-8.2l1.4 1.5c-.3.2-5.3 4.8-12.5 8.5Zm-12.8 3.4-.2-1 .2 1ZM180.1 138.667c-6.6 3.4-12.5 4.3-12.7 4.4l-.3-2c.1 0 5.8-.9 12.1-4.2 6.9-3.5 11.9-8.2 12-8.2l1.4 1.5c-.3.2-5.4 4.8-12.5 8.5Zm-12.9 3.4-.2-1 .2 1Z"
        fill="#75A5DE"
      />
      <path
        d="m175 135.767-4.1-1.3-2.4 3.6-4.1-2.1.4-.8 3.4 1.7 2.3-3.5 4 1.3 1.8-3.7 4.5.5 1.7-4.2h4.5l1-4.1.9.2-1.2 4.7-4.6.1-1.7 4.3-4.6-.5-1.8 3.8ZM179.7 144.467l-4.1-1.3-2.4 3.5-4.1-2 .4-.8 3.4 1.7 2.3-3.5 4 1.3 1.8-3.7 4.5.5 1.7-4.2 4.5-.1 1-4 .9.2-1.2 4.7h-4.6l-1.7 4.3-4.6-.5-1.8 3.9ZM170.4 127.067l-4-1.4-2.4 3.6-4.1-2.1.4-.8 3.4 1.7 2.3-3.4 4 1.3 1.8-3.8 4.5.5 1.7-4.2h4.5l1-4.1.9.2-1.2 4.8h-4.6l-1.7 4.3-4.6-.5-1.9 3.9Z"
        fill="#FFFAEC"
      />
      <path
        d="M181.3 121.567c.2.4 0 .9-.3 1.1-.4.2-.9 0-1.1-.3-.2-.4 0-.9.3-1.1.3-.2.9-.1 1.1.3ZM185.6 130.767c.2.4 0 .9-.3 1.1-.4.2-.9 0-1.1-.3-.2-.4 0-.9.3-1.1.4-.2.9-.1 1.1.3ZM174.5 125.467c.2.4 0 .9-.3 1.1-.3.2-.9 0-1.1-.3-.2-.4 0-.9.3-1.1.4-.2.9-.1 1.1.3ZM179.1 134.367c.2.4 0 .9-.3 1.1-.4.2-.9 0-1.1-.3-.2-.4 0-.9.3-1.1.4-.2.9-.1 1.1.3ZM172.8 137.367c.2.4 0 .9-.3 1.1-.4.2-.9 0-1.1-.3-.2-.4 0-.9.3-1.1.4-.2.9-.1 1.1.3ZM168 128.067c.2.4 0 .9-.3 1.1-.4.2-.9 0-1.1-.3-.2-.4 0-.9.3-1.1.4-.3.9-.1 1.1.3Z"
        fill="#F59DA7"
      />
      <g opacity=".3">
        <path
          opacity=".3"
          d="M180.6 117.967c1.7 1.8 3.1 3.8 4.1 5.5 3.3 6.4 1.2 15.1-5.2 18.4-2.4 1.3-5.2 1.5-7.8 1.1 3.7 2.6 8.6 3.4 12.7 1.3 6-3.1 7.9-11.2 4.9-17.1-1.7-3.1-4.9-6.9-8.7-9.2Z"
          fill="url(#paint34_linear_1891_11612)"
        />
      </g>
    </g>
    <path
      opacity=".1"
      d="M26.5 104.967c0 .4-2.3.7-5.1.7s-5.1-.3-5.1-.7c0-.4 2.3-.7 5.1-.7 2.9 0 5.1.3 5.1.7Z"
      fill="#000"
    />
    <mask
      id="mask4_1891_11612"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x="13"
      y="84"
      width="17"
      height="21"
    >
      <path
        d="M29.2 96.667c0 4.3-3.5 8.3-7.8 8.3s-7.8-4-7.8-8.3c0-4.3 2.5-11.7 7.8-11.7 4.9 0 7.8 7.4 7.8 11.7Z"
        fill="url(#paint35_linear_1891_11612)"
      />
    </mask>
    <g mask="url(#mask4_1891_11612)">
      <path
        d="M29.2 96.667c0 4.3-3.5 8.3-7.8 8.3s-7.8-4-7.8-8.3c0-4.3 2.5-11.7 7.8-11.7 4.9 0 7.8 7.4 7.8 11.7Z"
        fill="url(#paint36_linear_1891_11612)"
      />
      <path
        d="M20.8 90.367c-4.9 0-8.6-1.2-8.7-1.3l.9-2.7s3.5 1.1 7.8 1.1c4.9 0 8.9-1.1 9-1.1l.8 2.7c-.3.1-4.6 1.3-9.8 1.3ZM20.9 96.367c-4.9 0-8.6-1.2-8.7-1.3l.9-2.7s3.5 1.1 7.8 1.1c4.9 0 8.9-1.1 9-1.1l.8 2.7c-.3.1-4.6 1.3-9.8 1.3ZM20.9 102.367c-4.9 0-8.6-1.2-8.7-1.3l.9-2.7s3.5 1.1 7.8 1.1c4.9 0 8.9-1.1 9-1.1l.8 2.7c-.3.1-4.6 1.3-9.8 1.3Z"
        fill="#FFF7E4"
      />
      <g opacity=".3">
        <path
          opacity=".3"
          d="M26.9 88.967c.4 1.5.7 3.1.7 4.3 0 4.6-3.7 8.9-8.3 8.9-1.8 0-3.4-.6-4.7-1.6 1.3 2.6 3.9 4.4 6.8 4.4 4.3 0 7.8-4 7.8-8.3 0-2.2-.8-5.3-2.3-7.7Z"
          fill="url(#paint37_linear_1891_11612)"
        />
      </g>
    </g>
    <mask
      id="mask5_1891_11612"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x="24"
      y="88"
      width="16"
      height="20"
    >
      <path
        d="M38.9 97.367c1.2 3.8-.8 8.2-4.6 9.4-3.8 1.2-7.9-1.4-9.1-5.2-1.2-3.8-1-10.9 3.6-12.4 4.4-1.3 9 4.4 10.1 8.2Z"
        fill="url(#paint38_linear_1891_11612)"
      />
    </mask>
    <g mask="url(#mask5_1891_11612)">
      <path
        d="M38.9 97.367c1.2 3.8-.8 8.2-4.6 9.4-3.8 1.2-7.9-1.4-9.1-5.2-1.2-3.8-1-10.9 3.6-12.4 4.4-1.3 9 4.4 10.1 8.2Z"
        fill="url(#paint39_linear_1891_11612)"
      />
      <path
        d="M31.635 90.355a1 1 0 1 0-.276-1.981 1 1 0 0 0 .276 1.98ZM32.1 92.567a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        fill="#FFDF5F"
      />
      <path
        d="M33.2 91.067c-.5.2-1.1-.1-1.3-.7-.2-.6.1-1.1.7-1.3.5-.2 1.1.1 1.3.7.2.6-.2 1.2-.7 1.3ZM30.994 91.728a1 1 0 1 0-.591-1.911 1 1 0 0 0 .59 1.91Z"
        fill="#FFDF5F"
      />
      <path d="M31.8 90.967a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="#FFF7E4" />
      <path
        d="M25.6 98.067c.2.5-.1 1.1-.7 1.3-.5.2-1.1-.1-1.3-.7-.2-.5.1-1.1.7-1.3.6-.1 1.2.2 1.3.7ZM26.3 100.267c.2.5-.1 1.1-.7 1.3-.5.2-1.1-.1-1.3-.7-.2-.5.1-1.1.7-1.3.6-.2 1.1.1 1.3.7Z"
        fill="#FFDF5F"
      />
      <path
        d="M26.4 100.067c-.5.2-1.1-.1-1.3-.7-.2-.6.1-1.1.7-1.3.5-.2 1.1.1 1.3.7.1.6-.2 1.2-.7 1.3ZM24.07 100.757a1 1 0 1 0-.355-1.968 1 1 0 0 0 .354 1.968Z"
        fill="#FFDF5F"
      />
      <path d="M25.5 99.267c.1.3-.1.6-.4.7-.3.1-.6-.1-.7-.4-.1-.3.1-.6.4-.7.3 0 .6.1.7.4Z" fill="#FFF7E4" />
      <path
        d="M28.9 93.367c-.1.5-.7.9-1.3.7-.5-.1-.9-.7-.7-1.3.1-.5.7-.9 1.3-.7.5.2.8.8.7 1.3ZM28.3 95.567c-.1.5-.7.9-1.3.7-.5-.1-.9-.7-.7-1.3.1-.5.7-.9 1.3-.7.5.2.9.7.7 1.3Z"
        fill="#FFDF5F"
      />
      <path
        d="M28.4 95.467c-.5-.1-.9-.7-.7-1.3.1-.5.7-.9 1.3-.7.5.1.9.7.7 1.3-.2.5-.7.9-1.3.7ZM26.3 94.867c-.5-.1-.9-.7-.7-1.3.1-.5.7-.9 1.3-.7.5.1.9.7.7 1.3-.2.6-.8.9-1.3.7Z"
        fill="#FFDF5F"
      />
      <path d="M28.1 94.367c-.1.3-.4.5-.7.4-.3-.1-.5-.4-.4-.7.1-.3.4-.5.7-.4.3.1.5.4.4.7Z" fill="#FFF7E4" />
      <path
        d="M32.8 95.767c0 .6-.4 1.1-1 1.1s-1.1-.4-1.1-1 .4-1.1 1-1.1 1 .4 1.1 1ZM32.9 98.067c0 .6-.4 1.1-1 1.1s-1.1-.4-1.1-1 .4-1.1 1-1.1 1.1.4 1.1 1Z"
        fill="#FFDF5F"
      />
      <path
        d="M33 97.967c-.6 0-1.1-.4-1.1-1s.4-1.1 1-1.1 1.1.4 1.1 1c0 .5-.4 1-1 1.1ZM30.7 98.067c-.6 0-1.1-.4-1.1-1s.4-1.1 1-1.1 1.1.4 1.1 1-.4 1-1 1.1Z"
        fill="#FFDF5F"
      />
      <path d="M32.4 96.967c0 .3-.2.6-.5.6s-.6-.2-.6-.5.2-.6.5-.6c.3-.1.5.2.6.5Z" fill="#FFF7E4" />
      <path
        d="M37.1 95.667a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM38.2 96.767c0 .6-.4 1.1-1 1.1s-1.1-.4-1.1-1 .4-1.1 1-1.1 1.1.5 1.1 1Z"
        fill="#FFDF5F"
      />
      <path
        d="M38.2 96.667a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM36.1 96.867c-.6 0-1.1-.4-1.1-1s.4-1.1 1-1.1 1.1.4 1.1 1c0 .5-.5 1-1 1.1Z"
        fill="#FFDF5F"
      />
      <path d="M37.7 95.667c0 .3-.2.6-.5.6s-.6-.2-.6-.5.2-.6.5-.6.5.2.6.5Z" fill="#FFF7E4" />
      <path
        d="M36.8 102.067a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM35.4 103.067c-.5.3-1.1.1-1.4-.4-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.3.5.1 1.1-.4 1.4Z"
        fill="#FFDF5F"
      />
      <path
        d="M35.5 103.067c-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.3.5.1 1.1-.4 1.4-.5.3-1.1.1-1.4-.4ZM34.4 101.167c-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.3.5.1 1.1-.4 1.4-.5.2-1.1.1-1.4-.4Z"
        fill="#FFDF5F"
      />
      <path d="M36.1 102.067c-.3.2-.6.1-.7-.2-.2-.3-.1-.6.2-.7.3-.2.6-.1.7.2.2.2.1.6-.2.7Z" fill="#FFF7E4" />
      <path
        d="M31.6 102.867c-.5.3-1.1.1-1.4-.4-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.3.5.1 1.1-.4 1.4ZM29.7 103.967c-.5.3-1.1.1-1.4-.4-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.2.5 0 1.2-.4 1.4Z"
        fill="#FFDF5F"
      />
      <path
        d="M29.8 104.067c-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.3.5.1 1.1-.4 1.4-.5.2-1.1.1-1.4-.4ZM28.7 102.067c-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.3.5.1 1.1-.4 1.4-.5.3-1.2.1-1.4-.4Z"
        fill="#FFDF5F"
      />
      <path d="M30.4 103.067c-.3.2-.6.1-.7-.2-.2-.3-.1-.6.2-.7.3-.2.6-.1.7.2.1.2.1.5-.2.7Z" fill="#FFF7E4" />
      <path
        d="M35.5 107.467c-.5.3-1.1.1-1.4-.4-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.2.5 0 1.1-.4 1.4ZM33.5 108.567c-.5.3-1.1.1-1.4-.4-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.3.5.1 1.2-.4 1.4Z"
        fill="#FFDF5F"
      />
      <path
        d="M32.5 106.667c-.3-.5-.1-1.1.4-1.4.5-.3 1.1-.1 1.4.4.3.5.1 1.1-.4 1.4-.5.3-1.1.1-1.4-.4Z"
        fill="#FFDF5F"
      />
      <path d="M34.2 107.667c-.3.2-.6.1-.7-.2-.2-.3-.1-.6.2-.7.3-.2.6-.1.7.2.2.2.1.5-.2.7Z" fill="#FFF7E4" />
      <g opacity=".29">
        <path
          opacity=".29"
          d="M34.9 91.167c.8 1.2 1.4 2.5 1.8 3.6 1.2 4-.9 8.8-4.9 10.1-1.5.5-3.1.4-4.6-.2 1.9 1.9 4.6 2.9 7.2 2.1 3.8-1.2 5.7-5.6 4.6-9.4-.7-2-2.2-4.5-4.1-6.2Z"
          fill="url(#paint40_linear_1891_11612)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1891_11612"
        x1="209.45"
        y1="103.82"
        x2="220.463"
        y2="119.701"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AC1D2" />
        <stop offset=".999" stopColor="#1B92B4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1891_11612"
        x1="209.45"
        y1="103.82"
        x2="220.463"
        y2="119.701"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AC1D2" />
        <stop offset=".999" stopColor="#1B92B4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1891_11612"
        x1="214.096"
        y1="110.873"
        x2="220.298"
        y2="119.816"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AC1D2" />
        <stop offset=".999" stopColor="#1B92B4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1891_11612"
        x1="81.888"
        y1="158.992"
        x2="98.877"
        y2="105.946"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".93" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1891_11612"
        x1="92.577"
        y1="137.911"
        x2="113.87"
        y2="96.124"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".93" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1891_11612"
        x1="112.106"
        y1="94.71"
        x2="127.046"
        y2="109.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset=".999" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1891_11612"
        x1="112.106"
        y1="94.71"
        x2="127.046"
        y2="109.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset=".999" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1891_11612"
        x1="118.478"
        y1="101.393"
        x2="126.89"
        y2="109.805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset=".999" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1891_11612"
        x1="125.659"
        y1="53.647"
        x2="80.31"
        y2="74.442"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1F1F1" />
        <stop offset=".532" stopColor="#fff" />
        <stop offset="1" stopColor="#F1F1F1" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1891_11612"
        x1="52.483"
        y1="87.161"
        x2="89.407"
        y2="71.043"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1F1F1" />
        <stop offset=".532" stopColor="#fff" />
        <stop offset="1" stopColor="#F1F1F1" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_1891_11612"
        x1="147.277"
        y1="114.433"
        x2="168.776"
        y2="135.932"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset=".999" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_1891_11612"
        x1="147.277"
        y1="114.433"
        x2="168.776"
        y2="135.932"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset=".999" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_1891_11612"
        x1="156.446"
        y1="124.05"
        x2="168.552"
        y2="136.156"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset=".999" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_1891_11612"
        x1="164.059"
        y1="126.604"
        x2="190.719"
        y2="135.153"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B89BCB" />
        <stop offset=".999" stopColor="#9E78B8" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_1891_11612"
        x1="164.059"
        y1="126.604"
        x2="190.719"
        y2="135.153"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B89BCB" />
        <stop offset=".999" stopColor="#9E78B8" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_1891_11612"
        x1="175.618"
        y1="130.617"
        x2="190.63"
        y2="135.431"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B89BCB" />
        <stop offset=".999" stopColor="#9E78B8" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_1891_11612"
        x1="15.042"
        y1="89.065"
        x2="27.665"
        y2="101.688"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AC1D2" />
        <stop offset=".999" stopColor="#1B92B4" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_1891_11612"
        x1="15.042"
        y1="89.065"
        x2="27.665"
        y2="101.688"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AC1D2" />
        <stop offset=".999" stopColor="#1B92B4" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_1891_11612"
        x1="20.425"
        y1="94.712"
        x2="27.533"
        y2="101.82"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AC1D2" />
        <stop offset=".999" stopColor="#1B92B4" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_1891_11612"
        x1="24.46"
        y1="94.455"
        x2="38.975"
        y2="102.112"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC83C" />
        <stop offset=".999" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint39_linear_1891_11612"
        x1="24.46"
        y1="94.455"
        x2="38.975"
        y2="102.112"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC83C" />
        <stop offset=".999" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint40_linear_1891_11612"
        x1="30.722"
        y1="97.952"
        x2="38.895"
        y2="102.263"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset=".999" stopColor="#DC5B29" />
      </linearGradient>
      <radialGradient
        id="paint9_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-52.93 131.635 -57.057) scale(30.6797)"
      >
        <stop offset=".102" stopColor="#F9D8DC" />
        <stop offset=".769" stopColor="#F6B4BA" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(97.31642 -106.4198 89.39124 81.74452 169.525 24.216)"
      >
        <stop stopColor="#F1F1F1" />
        <stop offset=".532" stopColor="#fff" />
        <stop offset="1" stopColor="#F1F1F1" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 144.143 -111.452) scale(44.7292)"
      >
        <stop offset=".102" stopColor="#F9D8DC" />
        <stop offset=".769" stopColor="#F6B4BA" />
      </radialGradient>
      <radialGradient
        id="paint13_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 122.155 -131.108) scale(91.5494)"
      >
        <stop stopColor="#F1F1F1" />
        <stop offset=".532" stopColor="#fff" />
        <stop offset="1" stopColor="#F1F1F1" />
      </radialGradient>
      <radialGradient
        id="paint14_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 162.42 -136.469) scale(66.3846)"
      >
        <stop stopColor="#F1F1F1" />
        <stop offset=".548" stopColor="#fff" />
        <stop offset="1" stopColor="#F1F1F1" />
      </radialGradient>
      <radialGradient
        id="paint15_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 223.485 -110.843) scale(19.2413)"
      >
        <stop stopColor="#D1D2D3" />
        <stop offset=".634" stopColor="#F6F7F7" />
      </radialGradient>
      <radialGradient
        id="paint16_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 205.113 -141.036) scale(27.2542)"
      >
        <stop stopColor="#D1D2D3" />
        <stop offset=".263" stopColor="#E9EAEA" />
        <stop offset=".543" stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="paint17_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 156.08 -101.912) scale(30.3865)"
      >
        <stop offset=".575" stopColor="#fff" />
        <stop offset=".938" stopColor="#F1F1F1" />
      </radialGradient>
      <radialGradient
        id="paint18_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-43.136 168.668 -125.245) scale(1.24664)"
      >
        <stop offset=".023" stopColor="#434243" />
        <stop offset=".409" stopColor="#312F30" />
        <stop offset=".769" stopColor="#221F1F" />
      </radialGradient>
      <radialGradient
        id="paint19_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-43.136 176.263 -109.397) scale(1.24664)"
      >
        <stop offset=".023" stopColor="#434243" />
        <stop offset=".409" stopColor="#312F30" />
        <stop offset=".769" stopColor="#221F1F" />
      </radialGradient>
      <radialGradient
        id="paint20_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 172.805 -106.032) scale(4.06874 2.236)"
      >
        <stop offset=".005" stopColor="#FCDBD2" />
        <stop offset="1" stopColor="#FCDBD2" />
      </radialGradient>
      <radialGradient
        id="paint21_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 161.46 -116.706) scale(4.956)"
      >
        <stop offset=".102" stopColor="#F9D8DC" />
        <stop offset=".769" stopColor="#F6B4BA" />
      </radialGradient>
      <radialGradient
        id="paint22_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 173.202 -90.056) scale(4.956)"
      >
        <stop offset=".102" stopColor="#F9D8DC" />
        <stop offset=".769" stopColor="#F6B4BA" />
      </radialGradient>
      <radialGradient
        id="paint23_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 177.069 -101.92) scale(5.13979)"
      >
        <stop stopColor="#E6E5E5" />
        <stop offset=".661" stopColor="#fff" />
        <stop offset=".774" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="paint24_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 175.356 -104.513) scale(4.95159)"
      >
        <stop stopColor="#E6E5E5" />
        <stop offset=".661" stopColor="#fff" />
        <stop offset=".774" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="paint25_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 178.49 -92.86) scale(15.409)"
      >
        <stop offset=".206" stopColor="#EACBBB" />
        <stop offset=".753" stopColor="#DEA5A1" />
        <stop offset="1" stopColor="#F9C8D2" />
      </radialGradient>
      <radialGradient
        id="paint26_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 166.052 -100.965) scale(1.4422)"
      >
        <stop offset=".206" stopColor="#434243" />
        <stop offset=".769" stopColor="#221F1F" />
      </radialGradient>
      <radialGradient
        id="paint27_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 140.848 -75.735) scale(5.8337)"
      >
        <stop stopColor="#F8A560" />
        <stop offset="1" stopColor="#F27660" />
      </radialGradient>
      <radialGradient
        id="paint28_radial_1891_11612"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-47.561 140.751 -76.096) scale(1.031)"
      >
        <stop offset=".331" stopColor="#F2DD6A" />
        <stop offset="1" stopColor="#FDC770" />
      </radialGradient>
    </defs>
  </SvgIcon>
)
